module.exports = __webpack_public_path__ + "assets/img/btn-detail-1d4cbd59.png";